import { makeRequest } from '../../../lib/api';

const STATUS_PATH = '/v1/order_statuses';

class statusController {
  getStatusReferenceList = (data = {}) => {
    return makeRequest('get', `${ STATUS_PATH }?serviceId=${ data.serviceId }&sourceRefValueId=${ data.sourceRefValueId }`);
  };

  createStatusBind = (data = {}) => {
    return makeRequest('post', `${ STATUS_PATH }`, data);
  };

  updateStatusBind = (data = {}) => {
    return makeRequest('put', `${ STATUS_PATH }/${ data.id }`, data);
  };

  setPrimaryStatusBind = (statusBindId = {}) => {
    return makeRequest('put', `${ STATUS_PATH }/${ statusBindId }/primary`);
  };

  deleteStatusBind = (id) => {
    return makeRequest('delete', `${ STATUS_PATH }/${ id }`);
  };
}

export default new statusController();
